import React, { useContext } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import { BooleanColumn, NumericalColumn, StringColumn, CustomColumn } from 'baseui/data-table';

import { AppContext } from 'commons-ui';
import downloadImg from 'commons-ui/src/assets/misc/download.png';

export const COL_NAMES = {
	documentType: 'documentType',
	documentNumber: 'documentNumber',
	year: 'year',
	isActive: 'isActive',
	documentImage: 'documentImage',
	agentEmail: 'agentEmail'
};

export const columnConfigs = [
	StringColumn({
		title: 'Document Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.documentType]
	}),
	StringColumn({
		title: 'Document Number',
		maxWidth: 200,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.documentNumber]
	}),
	NumericalColumn({
		title: 'Year',
		maxWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.year] || 0
	}),
	BooleanColumn({
		title: 'isActive',
		maxWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	}),
	StringColumn({
		title: 'Uploaded By',
		maxWidth: 200,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.agentEmail]
	}),
	CustomColumn({
		title: 'Document Image',
		minWidth: 100,
		maxWidth: 100,
		mapDataToValue: (data: string) => _get(data, COL_NAMES.documentImage),
		renderCell: ({ value }: { value: string }) => {
			const { showAlert } = useContext(AppContext);
			const [css] = useStyletron();

			const handleClick = () => {
				if (!_isEmpty(value)) {
					window.open(value, '_blank');
					showAlert('Document Image downloaded successfully!');
				} else {
					showAlert('Document Image is not available!', { type: 'error' });
				}
			};

			return (
				<Button onClick={handleClick} size='mini' kind='tertiary'>
					<img className={css({ height: '20px', width: '20px' })} src={downloadImg} alt='download' />
				</Button>
			);
		}
	})
];
